// extracted by mini-css-extract-plugin
export var close = "ComparisonProductCard-module--close--e38d3";
export var container = "ComparisonProductCard-module--container--f722a";
export var dropdown = "ComparisonProductCard-module--dropdown--eb2c3";
export var icon = "ComparisonProductCard-module--icon--87d80";
export var image = "ComparisonProductCard-module--image--a2eb6";
export var imageWrapper = "ComparisonProductCard-module--imageWrapper--cd207";
export var productName = "ComparisonProductCard-module--productName--1cd38";
export var rating = "ComparisonProductCard-module--rating--cb308";
export var select = "ComparisonProductCard-module--select--3bbc1";
export var wrapper = "ComparisonProductCard-module--wrapper--e53d2";